<div class="page">
  <div class="page-single">
    <div class="container">
      <div class="row">
        <div class="col col-login mx-auto">
          <div class="text-center mb-6">
              <img src="./assets/images/logo.png" class="h-6" alt="">
          </div>
          <form class="card" [formGroup]="loginForm" (submit)="signin()">
            <div class="card-body p-6">
              <div class="card-title">Login to your account</div>
              <div class="form-group">
                <label class="form-label">Mobile</label>
                <input type="text" class="form-control" formControlName="mobile" placeholder="Enter Mobile No">
                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                    <div *ngIf="f.mobile.errors.required">Mobile No is required</div>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label">
                  Password
                </label>
                <input type="password" class="form-control" formControlName="password" placeholder="Password">
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
              </div>
              <div class="form-group">
                   <a href="/forget-password" class="float-right small">Forgot password</a>
              </div>
              <div class="form-footer">
                  <button type="submit" class="btn btn-primary btn-block" [disabled]="loading"><i class="fas fa-spin fa-spinner" *ngIf="loading"></i> Sign in</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="versionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-size:24px;">Information!</h5>
        
      </div>
      <div class="modal-body">
          Please Reload/Refresh the Browser.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="reloadScreen()">Reload</button>
      </div>
    </div>
  </div>
</div>